import { sanitizeParams } from '../auth/check-params';
import { Analytics } from '.';
import { AnalyticsType, } from '../../types/Analytics';
import { Amplitude } from './Amplitude';
import { analyticsEmitter } from './AnalyticsEventEmitter';
import { AnalyticsUtils } from './AnalyticsUtils';
import { RudderStack } from './RudderStack';
export const registerAndSendPageViewEvent = (pageType, data) => {
    AnalyticsUtils.registerPage(pageType, data);
    const pageViewEvent = {
        eventName: 'Page View',
        eventProperties: { Pagetype: pageType, Pagesource: sanitizeParams() },
        userProperties: {},
    };
    if (Amplitude.isReady) {
        Analytics.send(AnalyticsType.AMPLITUDE, pageViewEvent);
    }
    else {
        analyticsEmitter.on('amplitude', ({ isReady }) => {
            if (isReady) {
                Analytics.send(AnalyticsType.AMPLITUDE, pageViewEvent);
            }
        });
    }
    if (RudderStack.ready) {
        RudderStack.page(pageType.replaceAll(' ', '_').toLowerCase());
    }
    else {
        analyticsEmitter.on('rudderstack', ({ isReady }) => {
            if (isReady) {
                RudderStack.page(pageType.replaceAll(' ', '_').toLowerCase());
            }
        });
    }
};
